import { PxQuestionAnswerValue } from '../pxQuestions';
import type { PXQuestionsCollectionsResponse } from 'stash/types/apis/pxQuestions';

export const mapPxQuestionCollectionToState = (
	response: PXQuestionsCollectionsResponse
): Record<string, PxQuestionAnswerValue> => {
	if (!response.questions) {
		return {};
	}

	return response.questions.reduce<Record<string, PxQuestionAnswerValue>>((state, question) => {
		if (question.objectId == null) {
			return state;
		}

		state[question.objectId] = question.answer?.value;
		return state;
	}, {});
};
